import { Typography } from '@mui/material'

import { BaseLayout } from '@/components/layouts'
import { useTranslation } from '@/core'
import { Cell, CellFrame, Template } from '@/core/architecture'

import { MailAuthForm, MailAuthFormProps } from './MailAuthForm'

export * from './fragments'

export type State = {
  verifyEmailSending: boolean
}

export type Action = {
  onSubmitMailAuth: MailAuthFormProps['onSubmitMailAuth']
  onResendAuthMail: MailAuthFormProps['onResendAuthMail']
}

export const MailAuthTemplate: Template<State, Action> = ({
  state,
  onSubmitMailAuth,
  onResendAuthMail,
}) => {
  const { t } = useTranslation('mailAuth')

  return (
    <BaseLayout
      margin
      header={{
        title: t('title'),
        back: true,
      }}
    >
      <TextCell />
      <MailAuthForm
        loading={state.verifyEmailSending}
        onSubmitMailAuth={onSubmitMailAuth}
        onResendAuthMail={onResendAuthMail}
      />
    </BaseLayout>
  )
}

const TextCell: Cell = () => {
  const { t } = useTranslation('mailAuth')

  return (
    <CellFrame
      sx={{
        py: 2,
      }}
    >
      <Typography variant="body2" color="text.primary">
        {t('description')}
      </Typography>
    </CellFrame>
  )
}
